// extracted by mini-css-extract-plugin
export default {"container":"splash_container__i3Q9-","isContainer":"splash_isContainer__1MFQt","inner":"splash_inner__2b_P3"};